import React from "react";
import { useTranslation } from "react-i18next";

import { useMatomo } from "@datapunt/matomo-tracker-react";

import { makeStyles } from "@material-ui/styles";
import { Divider, Grid, Typography } from "@material-ui/core";

import { useDocTitle } from "../../components/_common/DocTitle";
import TabsFAQ from "./TabsFAQ";
import TabsAbout from "./TabsAbout";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: "100%",
    },
    tabTitle: {
        textTransform: "initial",
        fontWeight: 500,
    },
    tabImg: {
        maxWidth: 72,
    },
    bigTitle: {
        fontSize: "clamp(1.5rem, 2vw, 2rem)",
        fontWeight: "normal",
        margin: theme.spacing(5.25, 4, 8, 4),
        textAlign: "center",
        justifyContent: "center",
    },
}));

const HomePage = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    useDocTitle("Strona główna - Repozytorium Systemów Informacyjnych");

    // Track page view
    const { trackPageView } = useMatomo();
    React.useEffect(() => {
        trackPageView();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Typography
                        variant="h4"
                        className={classes.bigTitle}
                        color="primary"
                        component={"h2"}
                        id={"page-content"}
                        tabIndex={0}
                    >
                        {t("Informacje ogólne")}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TabsFAQ />
                    <Divider style={{ margin: "40px 0" }} />
                </Grid>
                <Grid item xs={12}>
                    <TabsAbout />
                    {/* <Divider /> */}
                </Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={12}></Grid>
            </Grid>
        </>
    );
};

export default HomePage;
